<template>
  <div id="nav-view">
    <!-- 顶部导航 -->
    <topNav :menuTree="isSwitch2WmsMenu ? wmsMenuTree : spmMenuTree"></topNav>
    <!-- 内容部分 -->
         
    <div class="content-box" :class="[
      isCollapseCom ? 'sider-collapse' : '',
      !menuRouterIndex ? 'home-page' : '',
      isCollapseAllSide ? 'hide-side-all' : ''
    ]">
      <div class="content-left" v-if="menuRouterIndex">
        <el-scrollbar :wrap-class="{ 'scrollbar-wrapper': true }" >
          <!-- 常用菜单 -->
          <template>
            <div class="search-menus">
              <el-input
                class="search-input"
                :placeholder="$t('quickEntranceEnterMenu')"
                size="small"
                prefix-icon="el-icon-search"
                v-model="searchValue"
                @input="searchValueChange">
              </el-input>
              <quickEntrance @comfirm="queryQuickAddedList"></quickEntrance>
            </div>
            <div v-if="filterMenus.length === 0 && filterCommonMenus.length === 0">
              <div class="empty-block">
                <div class="empty-icon"></div>
                <div class="empty-text">{{ $t('quickEntranceNoResult') }}</div>
              </div>
            </div>

            <div class="common-menu" v-if="(filterMenus.length > 0 || filterCommonMenus.length > 0) ">
                <div class="menu-title" :class="{'open': showCollect}" @click="showCollect = !showCollect">
                  <div class="menu-title1">
                      <i class="enter-icon"></i>
                      <span class="title">
                        {{ $t('quickEntranceCommonMenu') }}
                      </span>
                      <span class="selected-num">{{ filterCommonMenus.length }}</span>
                      <span class="total-num">/10</span>
                  </div>
                  <i class="el-icon-arrow-down"></i>
                </div>

              <el-collapse-transition>
                <ul class="selected-menu-list" v-show="showCollect" style="transform-origin: center top; ">
                  <li class="list-item" v-for="(menu, index) in filterCommonMenus" :key="menu.path" @click="moveToPath(menu)">
                    <span style="max-width: 134px;">
                      <ToolTips :text="$t(menu.translation)" effect="dark" placement="top">
                          {{ $t(menu.translation) }}
                      </ToolTips>
                    </span>
                    <i class="el-icon-star-on" @click="removeSelectMenu(index)"></i>
                  </li>
                </ul>
              </el-collapse-transition>
            </div>
          </template>
          <!-- 常规子菜单 -->
          <el-menu
            class="el-menu-vertical"
            router
            :unique-opened="true"
            :collapse="false"
            :default-active="$route.path"
            :default-openeds="openeds"
          >
            <LeftNavOfWms v-if="isSwitch2WmsMenu" :menuTree="subWmsMenuTree"></LeftNavOfWms>
            <LeftNavOfSpm v-else :menuTree="filterMenus"></LeftNavOfSpm>
          </el-menu>
        </el-scrollbar>
        <!-- 左侧菜单引导 -->
        <!-- <MenuGuide v-if="showMenuGuide"></MenuGuide> -->
      </div>
      
      <div class="new-menu-right-content">
        <tags-view :menuLinkList = "isSwitch2WmsMenu ? wmsMenuLinkList : spmMenuLinkList">
          <transition name="fade" mode="out-in">
            <router-view ref='_contentView'/>
          </transition>
        </tags-view>
        <!-- <div class="icon-popover">
          <span  class="item-img">
            <el-tooltip effect="dark" content="问卷调查" placement="top">
              <img src="@/assets/images/icon_Lui-icon-edit1.png" alt="">
            </el-tooltip>
          </span>
          <el-popover
            class="item-img"
            placement="left-end"
            trigger="hover">
            <div>11111111</div>
            <img  slot="reference" src="@/assets/images/icon_Lui-icon-edit.png" alt="">
          </el-popover>
          <el-popover
            class="item-img"
            placement="left-end"
            trigger="hover">
            <div>11111111</div>
            <img  slot="reference" src="@/assets/images/icon_Lui-icon-edit2.png" alt="">
          </el-popover>
          <el-popover
            class="item-img"
            placement="left-end"
            trigger="hover">
            <div>11111111</div>
            <img  slot="reference" src="@/assets/images/icon_Lui-icon-edit3.png" alt="">
          </el-popover>
        </div> -->
      </div>
    </div>
    <image-print-template/>
  </div>
</template>

<script>
  import imagePrintTemplate from '../components/ImagePrintTemplate'
  import topNav from '@/components/newMenu/topNav'
  import LeftNavOfWms from '@/components/newMenu/leftNavOfWms'
  import LeftNavOfSpm from '@/components/newMenu/leftNavOfSpm'
  import * as localStorage from '../api/utils/storage/localStorage'
  import { mapGetters } from 'vuex'
  import { i18n } from '@/api/i18n'
  import TagsView from '../components/newMenu/tagsView'
  import {MenuEnum} from '../api/biz/menuEnumNew.js'
  import { isMenuCacheExpired, markMenuCacheVer } from '@/menu/menuCache'
  import { userInfo,wareHouseInfo,routerule, domain, $notify, syncUserInfo } from '../global'
  import {restUrls} from '@/api/rest/url'
  import axios from 'axios'
  import _ from 'lodash'
  import Cookies from 'js-cookie'
  import Print from 'vue-print-nb';
  import quickEntrance from '@/components/newMenu/quickEntrance.vue'
  import ToolTips from '../components/newMenu/components/ToolTips.vue'
  import API from '@/api'
  import MenuGuide from '@/components/newMenu/components/MenuGuide.vue'
  import Vue from 'vue'
  Vue.use(Print);

  export default {
    components: {
      TagsView,
      topNav,
      LeftNavOfWms,
      LeftNavOfSpm,
      imagePrintTemplate,
      quickEntrance,
      ToolTips,
      MenuGuide
    },
    watch: {
      $route: {
        immediate: true,
        handler(newValue, oldValue) {
          if(newValue.name === 'index'){
            this.$store.commit('SET_MENU_ROUTER_INDEX',true)
          }else{
            this.$store.commit('SET_MENU_ROUTER_INDEX',true)
          }
          // const menu = this.spmMenuLinkList.find(item => item.url === newValue.path)
          // const topIndex = menu ? menu.topIndex : -1
          // this.$store.commit('SET_TOP_INDEX', topIndex)
        }
      },
      spmMenuLinkList: {
        handler(newValue) {
          const menu = newValue.find(item => item.url === this.$route.path)
          const topIndex = menu ? menu.topIndex : -1
          this.$store.commit('SET_TOP_INDEX', topIndex)
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      ...mapGetters([
        'isCollapse',
        'isCollapseAllSide'
      ]),
      isCollapseCom(){
        return this.isCollapse
      },
      isHomePage(){
        return this.isCollapseAllSide
      },
      menuRouterIndex(){
        return this.$store.state.appStore.menuRouterIndex
      },
      isShow(){
        let s = Cookies.get('lwms.layout.show')
        if(!_.isEmpty(s) && s == '0'){
          return false;
        }
        let showFlag = this.getQueryString('s');
        if(_.isEmpty(showFlag) || showFlag == 1){
          return true;
        }
        Cookies.set('lwms.layout.show', '0', { domain: domain() });
        return false;
      },
      isSwitch2WmsMenu() {
        return Cookies.get('lwms.s2wm') === 'true'
      },
      subWmsMenuTree() {
        if(this.wmsMenuTree.length && this.wmsMenuTree[this.topIndex] && this.wmsMenuTree[this.topIndex].children) {
          return this.wmsMenuTree[this.topIndex].children
        } else {
          return []
        }
      },
      subSpmMenuTree() {
        if(this.spmMenuTree.length && this.spmMenuTree[this.topIndex] && this.spmMenuTree[this.topIndex].children) {
          return this.spmMenuTree[this.topIndex].children
        } else {
          return []
        }
      },
      commonMenus() {
        return this.$store.state.appStore.collectMenus || []
      },
      filterMenus() {
        if(this.searchValue !== '') {
          const res = this.filterTree(this.searchValue, this.spmMenuTree)
          return res
        } else {
          return this.subSpmMenuTree;
        }
      },
      // 搜索常用菜单
      filterCommonMenus() {
        if(this.searchValue !== '') {
          const res = this.commonMenus.filter(item => this.$t(item.translation).indexOf(this.searchValue) > -1)
          return res
        } else {
          return this.commonMenus
        }
      },
      // 顶部index
      topIndex() {
        return this.$store.state.appStore.currentTopIndex
      }
    },
    data(){
      return {
        wmsMenuTree: [],
        spmMenuTree: [],
        // isCollapse: this.$store.getters.isCollapse,
        // isCollapse: true,
        activeIndex: '0',
        wmsMenuLinkList: [],
        spmMenuLinkList: [],
        searchValue: '',
        queryQuickAdded: [],
        routeAdded: [],
        showCollect: false,
        showMenuGuide: true,
        openeds: []
      }
    },
    methods: {
      searchValueChange(val){
        if(val && this.filterMenus && this.filterMenus.length && !this.isSwitch2WmsMenu){
          let arr = [];
          this.filterMenus.map((item) => {
            arr.push(item.id && item.id.toString());
            item.children.map((item2) => {
              arr.push(item2.id && item2.id.toString());
            });
          })
          this.openeds = arr;
        } else {
          this.openeds = []
        }
      },
      buildWmsMenuLinkList(menuList) {
        if(!menuList){
          return
        }
        for (let item of menuList) {
          item.baseUrl = item.menuLink
          if (item.nodeType === 2) {
            this.wmsMenuLinkList.push(item)
          }
          if (item.childs && item.childs.length != 0) {
            this.buildWmsMenuLinkList(item.childs)
          }
        }
      },
      buildSpmMenuLinkList(spmMenuList, isRoot, topIndex) {
        if(!spmMenuList){
          return
        }
        for (let [index,item] of spmMenuList.entries()) {
          item.isMatched = _.isPlainObject(MenuEnum[item.code])
          item.translation = item.isMatched && MenuEnum[item.code].translation ? MenuEnum[item.code].translation : ''
          item.css = item.isMatched && MenuEnum[item.code].css ? MenuEnum[item.code].css : ''
          item.showInMenu = MenuEnum[item.code] && MenuEnum[item.code].showInMenu
          item.baseUrl = item.url
          item.topIndex = isRoot ? index : topIndex
          if (!_.isEmpty(item.url)) {
            this.spmMenuLinkList.push(item)
          }
          if (item.children && item.children.length !== 0) {
            this.buildSpmMenuLinkList(item.children, false, item.topIndex)
          }
        }
      },
      clearMenuTab () {
        this.$store.state.appStore.visitedViews = []
        this.$store.state.appStore.cachedViews = []
      },
      getQueryString(name) {
        return (decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null);
      },
      queryMenuList(){
        this.clearMenuTab();
        let _this = this;
        axios.get(restUrls.query_menu_list_url+"?_t_=" + new Date().getTime(), {timeout: 60000,headers:{'X-Requested-With': 'XMLHttpRequest' }}).then(response => {
            try{
              let x = response.data;
              console.log("请求url：" + restUrls.query_menu_list_url + " from nav, 返回：" + JSON.stringify(x));
              if(x.resultCode != 1){
                //$notify.error(i18n.t('loginFail'))
                return;
              }

              let curUser = JSON.parse(x.resultValue).userInfo;
              userInfo.userCode = curUser.userCode;
              userInfo.userName = curUser.userName;
              userInfo.orgNo = curUser.orgCode;
              userInfo.distributeNo = curUser.deliveryCode;
              userInfo.warehouseNo = curUser.warehouseCode;

              wareHouseInfo.orgNo = curUser.orgCode;
              wareHouseInfo.distributeNo = curUser.deliveryCode;
              wareHouseInfo.warehouseNo = curUser.warehouseCode;

              routerule.value = userInfo.orgNo + ',' + userInfo.distributeNo + ',' + userInfo.warehouseNo
              // 接口返回的用户信息同步进 Vuex（单一来源）
              syncUserInfo({})

              _this.wmsMenuTree = JSON.parse(x.resultValue).menuTree.childs;
              console.log("🚀 ~ axios.get ~  _this.wmsMenuTree:",  _this.wmsMenuTree)
              _this.buildWmsMenuLinkList(_this.wmsMenuTree)
              localStorage.setLocalStorgeValue("lwmsLoginUserWmsMenuTreeNew",JSON.stringify(_this.wmsMenuTree));
              markMenuCacheVer(`lwmsLoginUserWmsMenuTreeNew-${Cookies.get('userName')}`)

              window.addEventListener('beforeunload', e => {
                if(_this.$store && _this.$store.state.appStore.visitedViews.length > 1) {
                  window.localStorage.setItem('tags', JSON.stringify(_this.$store.state.appStore.visitedViews))
                }
              })
            }
            catch(e){
              console.log(e);
            }
          },
          error=>{
              console.log(error);
          }
        ).catch(function (error) {
            console.log(error);
          });
      },
      queryMenuListOfSpm(){
        this.clearMenuTab();
        let _this = this;
        axios.get(restUrls.query_spm_resource_list_url+"?root=iWMS&_t_=" + new Date().getTime(), {timeout: 60000,headers:{'X-Requested-With': 'XMLHttpRequest' }}).then(response => {
            try{
              let x = response.data;
              console.log("请求url：" + restUrls.query_spm_resource_list_url + " from nav, 返回：" + JSON.stringify(x));
              if(x.resultCode != 1){
                //$notify.error(i18n.t('loginFail'))
                return;
              }
              // 数据处理
              _this.spmMenuTree = JSON.parse(x.resultValue);
              _this.spmMenuTree.map((item, index) => {
                item.initIndex = index
              })
              _this.buildSpmMenuLinkList(_this.spmMenuTree, true, -1)
              this.$store.commit('SET_MENU_ROUTER_LINK', _this.spmMenuTree)
              localStorage.setLocalStorgeValue(`lwmsLoginUserSpmMenuTreeNew-${Cookies.get('userName')}-${Cookies.get('warehouseNo')}`, x.resultValue);
              markMenuCacheVer(`lwmsLoginUserSpmMenuTreeNew-${Cookies.get('userName')}-${Cookies.get('warehouseNo')}`)

              window.addEventListener('beforeunload', e => {
                if(_this.$store && _this.$store.state.appStore.visitedViews.length > 1) {
                  window.localStorage.setItem('tags', JSON.stringify(_this.$store.state.appStore.visitedViews))
                }
              })
            }
            catch(e){
              console.log(e);
            }
          },
          error=>{
              console.log(error);
          }
        ).catch(function (error) {
            console.log(error);
          });
      },
      // 查询收藏的菜单
      async queryQuickAddedList() {
        const res = await API.queryFavoriteMenuList()
        let data = res.data && res.data.resultValue &&  JSON.parse(res.data.resultValue)
        if(_.isEmpty(data)){
          data = [
            {
                "id": 713834,
                "parentId": 713833,
                "code": "iWMS-PRODUCT-MAINTAIN",
                "name": "商品管理",
                "url": "/productMaintain",
                "type": 0,
                "level": 5,
                "seq": 1,
                "translation": "iWMS-PRODUCT-MAINTAIN"
            },
            {
                "parentId": 713397,
                "id": 713785,
                "name": "任务分配",
                "code": "iWMS-TASKASSIGN",
                "url": "/taskAssign",
                "level": 5,
                "seq": 1,
                "type": 0,
                "children": null,
                "isMatched": true,
                "translation": "iWMS-TASKASSIGN",
                "css": "",
                "baseUrl": "/taskAssign",
                "topIndex": 1
            }
        ]
        }
        this.$store.commit('SET_COLLECT_MENUS', data)
        console.log(data,'data')
        // // 设置快捷入口
        this.queryQuickAdded = [...data]
        // // 设置已添加的快捷入口
        this.routeAdded = [...this.queryQuickAdded]
      },
      // 移除收藏的菜单
     async removeSelectMenu(idx) {
        this.routeAdded = this.commonMenus
        console.log(this.routeAdded,idx)
        let code = this.routeAdded && this.routeAdded[idx] && this.routeAdded[idx].code
        const result = await API.cancelFavoriteMenu({'code':code})
        if(result.data && result.data.resultCode == 1){
          this.routeAdded.splice(idx, 1)
          try {
            // 设置快捷入口
            this.queryQuickAdded = [...this.routeAdded]
            this.$notify.success({
              title: this.$t('success'),
              message: this.$t('quickEntranceDeleteSuccessed')
            })
            this.$store.commit('SET_COLLECT_MENUS', this.routeAdded)
          } catch (error) {
            console.log(error)
          }
          }else{
          this.$message.error(this.$t(result.data.resultCode));
        }
      },
      moveToPath(menu) {
        this.$router.push(menu.url)
      },
      filterTree (val, tree, newArr = []) {
        let _expandKeys_  = []
        if (!(tree.length && val)) {  // 如果搜索关键字为空直接返回源数据
          _expandKeys_ = defaultOpenKeyArr  //这块是为了记录tree的展开key可以忽略
          return tree
        }
        for (let item of tree) {
          const key = item.translation ? item.translation : item.name
          if (this.$t(key).indexOf(val) > -1) { // 匹配到关键字的逻辑
            newArr.push(item)  // 如果匹配到就在数值中添加记录
            if (item.children) _expandKeys_.push(item.key)  //这块是为了记录tree的展开key可以忽略
            continue  // 匹配到了就退出循环了此时如果有子集也会一并带着
          }
          if (item.children && item.children.length) { // 如果父级节点没有匹配到就看看是否有子集，然后做递归
            _expandKeys_.push(item.key)  //这块是为了记录tree的展开key可以忽略
            let subArr = this.filterTree(val, item.children) // 缓存递归后的子集数组
            if (subArr && subArr.length) {  // 如果子集数据有匹配到的节点
              let node = { ...item, children: subArr }  // 关键逻辑，缓存父节点同时将递归后的子节点作为新值
              newArr.push(node)  // 添加进数组
            }
          }
        }
        return newArr
      }
    },
    mounted() {
      // 是否切换到wms自身菜单
      const switch2WmsMenu = Cookies.get('lwms.s2wm') === 'true'
      const wmsCacheKey = `lwmsLoginUserWmsMenuTreeNew-${Cookies.get('userName')}`
      const spmCacheKey = `lwmsLoginUserSpmMenuTreeNew-${Cookies.get('userName')}-${Cookies.get('warehouseNo')}`
      let wmsMenuTreeJson = localStorage.getLocalStorgeValue(wmsCacheKey)
      let spmMenuTreeJson = localStorage.getLocalStorgeValue(spmCacheKey)
      // 菜单缓存半天(12h)过期，从上次写缓存算起；过期视同无缓存，强制重拉
      if (isMenuCacheExpired(wmsCacheKey)) wmsMenuTreeJson = ''
      if (isMenuCacheExpired(spmCacheKey)) spmMenuTreeJson = ''
      let collectedMenus = localStorage.getLocalStorgeValue('commonMenus');
      let topIndexLocal = localStorage.getLocalStorgeValue('topIndex')
       // 是否需要显示新手引导
      const strVisitedMenuGuide = localStorage.getLocalStorgeValue('visitedLeftMenuGuide')
      const visitedMenuGuide = strVisitedMenuGuide ? JSON.parse(strVisitedMenuGuide) : []
      this.showMenuGuide = !visitedMenuGuide.includes(userInfo.userCode)
      if(topIndexLocal) {
        this.$store.commit('SET_TOP_INDEX', JSON.parse(topIndexLocal))
      } else {
        this.$store.commit('SET_TOP_INDEX', 0)
      }
      if(collectedMenus) {
        const payload = JSON.parse(collectedMenus)
        this.$store.commit('SET_COLLECT_MENUS', payload)
      } else {
        this.queryQuickAddedList()
      }
      if(switch2WmsMenu && _.isEmpty(wmsMenuTreeJson)){
        this.queryMenuList()
        return
      }
      if(!switch2WmsMenu && _.isEmpty(spmMenuTreeJson)){
        this.queryMenuListOfSpm()
        return
      }
      if(switch2WmsMenu) {
        this.wmsMenuTree = JSON.parse(wmsMenuTreeJson)
        this.buildWmsMenuLinkList(this.wmsMenuTree)
      } else {
        this.spmMenuTree = JSON.parse(spmMenuTreeJson)
        this.buildSpmMenuLinkList(this.spmMenuTree, true, -1)
        this.$store.commit('SET_MENU_ROUTER_LINK', this.spmMenuTree)
      }

      window.addEventListener('beforeunload', e => {
        if(this.$store && this.$store.state.appStore.visitedViews.length > 1) {
          window.localStorage.setItem('tags', JSON.stringify(this.$store.state.appStore.visitedViews))
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
#nav-view{
  height: 100vh;
  background-color: #f5f5f6;
  .el-header {
    border-bottom: 1px solid #F1F2F4;
    padding: 0;
  }
  .content-box {
    padding-left: 220px;
    &.home-page {
      padding-left: 0 !important;
    }
    &.sider-collapse {
      padding-left: 64px;
      .content-left {
        width: 64px;
        .common-menu {
          display: none;
        }
        /deep/.el-submenu {
          .el-menu {
            display: none;
          }
        }
        /deep/.el-submenu__title {
          span{
            visibility: hidden;
          }
        }
        &:hover {
          width: 220px;
          transition: all 0.28s;
          .common-menu {
            display: block;
          }
          /deep/.el-submenu {
            .el-menu {
              display: block;
            }
          } 
          /deep/.el-submenu__title {
            span{
              visibility: visible;
            }
          }
        }
      }
    }
    &.hide-side-all{
      padding-left: 0 !important;
      .content-left{
        width: 0px;
        transition: all 0.15s;
      }
    }
    .content-left {
      width: 220px;
      height: 100%;
      background-color: #fff;
      position: fixed;
      font-size: 0px;
      top: 64px;
      bottom: 0;
      left: 0;
      z-index: 90;
      border-radius: 0 12px 0 0;
    }
    .new-menu-right-content {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      padding: 0;
      margin-left: 1px;
      overflow-x: hidden;
      position: relative;
      .icon-popover{
        display:flex;
        position: fixed;
        z-index: 100;
        bottom: 200px;
        right: -22px;
        width: 48px;
        background: skyblue;
        flex-direction: column;
        border-radius: 4px;
        box-shadow:  0 4px 15px 0 rgba(0,0,0,0.1);
        &:hover{
          right: 0px;
        }
        .item-img{
          display:inline-block;
          width:32px;
          height:32px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          margin-top: 8px;
          margin-bottom: 8px;
          &:hover{
            background-color:#E4E5E9;
          }
        }
        img{
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}
.el-scrollbar {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-x: hidden;
  border-right: 1px solid #F1F2F4;
  .el-menu-vertical:not(.el-menu--collapse) {
    width: auto;
    min-height: 100px !important;
    overflow-y: auto;
    overflow-x: auto;
  }
  /* 全局菜单项样式，让文本换行显示 */
  /deep/ .el-menu-item {
    height: auto !important;
    min-height: 40px !important;
    line-height: 1.4 !important;
    padding: 8px 30px 8px 40px !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    display: flex !important;
    align-items: center !important;
    
    span {
      flex: 1;
      word-wrap: break-word;
      white-space: normal !important;
      line-height: 1.4;
      padding-right: 0;
    }
    .el-icon-star-on {
      right: -3px !important;
    }
  }
  /* 子菜单标题样式 */
  /deep/ .el-submenu__title {
    height: auto !important;
    min-height: 40px !important;
    line-height: 1.4 !important;
    padding: 8px 20px !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    
    span {
      word-wrap: break-word;
      white-space: normal !important;
      line-height: 1.4;
    }
  }
  /deep/ .scrollbar-wrapper {
    overflow-x: hidden;
    padding: 0 8px;
    height: calc(100% - 80px);
    .search-menus {
      display: flex;
      align-items: center;
      padding-right: 3px;
      margin-top: 8px;
      .search-input {
        .el-input__inner {
          border: none;
          background: rgba(243,243,243,1);
          border-radius: 8px;
          padding-left: 32px !important;
          padding-right: 15px !important;
        }
        .el-input__prefix{
          left: 5px !important;
          right: auto !important;
        }
      }
      .el-icon-setting {
        margin-left: 13px;
        color: #787878;
        font-size: 18px;
        font-weight: 400;
        cursor: pointer;
        &:hover {
          color: #3C6EF0;
        }
      }
    }
    .empty-block{
      width: 100%;
      padding-top: 121px;
    }
    .empty-icon{
      width: 60px;
      height: 40px;
      background-color: hsla(0, 0%, 100%, .1);
      margin: auto;
      margin-top: 32px;
      background-image: url(../assets/images/noMenu.png);
      background-size: contain;
      background-position: 50%;
      background-repeat: no-repeat;
    }

    .empty-text {
      height: 18px;
      line-height: 18px;
      text-align: center;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: normal;
      color: rgba(180,180,180,1);
      margin-top: 20px;
    }
    .common-menu {
      // display: none;
      transition: display 0.28s;
      .menu-title, .menu-title1 {
        width: 204px;
        height: auto;
        line-height: 40px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #666;
        &.open {
          .el-icon-arrow-down {
            transform: rotateZ(180deg);
          }
        }
        .el-icon-star-off {
          font-size: 18px;
          margin-left: 16px;
          margin-right: 10px;
          font-weight: 400;
        }
        .title {
          margin-left: 6px;
          font-size: 14px;
          font-family: PingFang SC;
          color: rgba(51,51,51,1);
          max-width: 110px;
          height: auto;
          line-height: 1.5;
        }
        .selected-num {
          font-size: 14px;
          font-family: JDZhengHT;
          color: rgba(102,102,102,1);
          margin-left: 6px;
        }
        .total-num {
          font-size: 13px;
          font-family: JDZhengHT;
          color: rgba(201,201,201,1);
        }
        .el-icon-arrow-down {
          justify-self: flex-end;
          transform: rotateZ(-0deg);
          color: #999;
          font-size: 12px;
          transition: all 0.1s linear;
        }
        .menu-icon {
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url('https://img12.360buyimg.com/imagetools/jfs/t1/237054/3/5484/1379/656e9effFd91d6840/14155da99b61037d.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      .menu-title {
        box-sizing: border-box;
        padding: 8px 20px;
        padding-right: 8px;
        &:hover {
          background: rgba(60,110,240,0.1);
          border-radius: 6px;
          .title {
            color: #3C6EF0;
          }
          .menu-icon {
            background: url('https://img11.360buyimg.com/imagetools/jfs/t1/222066/30/36625/1071/656e9effF4e18f1f8/421aa8df7a583d8c.png') no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      .selected-menu-list {
        animation: all 1s linear;
        padding: 0;      
        .list-item {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          // min-height: 40px;
          padding: 11px 4px 11px 16px;
          width: 180px;
          cursor: pointer;
          position: relative;
          span {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: normal;
            color: rgba(102,102,102,1);
            word-wrap: break-word;
            white-space: pre-wrap !important;
            cursor: pointer;
            line-height: 16px;
            margin-right: 6px;
            flex: 1;
          }
          .el-icon-star-on {
            color: #FECB52;
            font-size: 20px;
            line-height: 16px;
            // margin-top: 2px;
            flex-shrink: 0;
            // position: absolute;
            // right: 0;
            // top: 50%;
            // margin-top: -10px;
          }
          &:hover {
            background: rgba(60,110,240,0.1);
            border-radius: 6px;
            span {
              color: #3C6EF0;
            }
            .el-icon-star-on {
              color: #FEA452;
            }
          }
        }
      }
    }
    .menu-first-level {
      width: 180px;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #3C6EF0;
      padding-left: 15px;
      height: 40px;
      line-height: 50px;
      display: none;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .enter-icon {
    width: 20px;
    height: 20px;
    background-image: url("https://img12.360buyimg.com/imagetools/jfs/t1/237054/3/5484/1379/656e9effFd91d6840/14155da99b61037d.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    display: inline-block;
    margin-right: 6px;
    flex-shrink: 0;
  }
}

</style>